// react
import React, { Component } from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";

// application
import StroykaSlick from "../shared/StroykaSlick";
import { ArrowPointToLeft, ArrowPointToRight } from "../../svg";

const faqList = [
    {
        title: "How long does the perfume last?",
        desc: "Once opened, it will perfume your car for up to 60 days, depending on where it is placed. Heat, sunlight, wind & humidity can all affect how long the air fragrance will last.",
    },
    {
        title: "How does it work?",
        desc: "Open the jar’s lid and remove the cover inside. Then close back the lid and place the air fragrance in your dashboard or cup holder. For the miniature air fragrance, you can clip it in the AC vent.",
    },
    {
        title: "Will it fall when I'm driving?",
        desc: "No, it won’t. The bottle jar is just the right size and will sit comfortably in your dashboard or inside your car’s cup holder.\n\nHowever, accidents do happen. If for some reason the air fragrance accidentally falls from its place, you don’t need to worry since the content is made of gel like substance. It won’t instantly pour out, keeping your interior safe from gooey mess.",
    },
    {
        title: "What ingredients do you use?",
        desc: "It’s free from harmful chemicals, alcohol-free, formaldehyde, benzene, and toluene. It will give your car a refreshing fragrance without risking your health.",
    },
    {
        title: "How long would the car perfumes last if they are unopened?",
        desc: "Our air fragrance will last five years or more if left unopened and kept in a cool, dry place.",
    },
    {
        title: "Is it refillable?",
        desc: "Since the air fragrance is designed in gel form, it’s not refillable.",
    },
];
const settings = {
    dots: false,
    arrow: false,
    infinite: false,
    // autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
};

export default class FAQ extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0,
        };
    }

    handleNextClick = () => {
        if (this.slickRef) {
            this.slickRef.slickNext();
            setTimeout(() => this.setCurrentSlide(this.slickRef.innerSlider.state.currentSlide), 100);
        }
    };

    handlePrevClick = () => {
        if (this.slickRef) {
            this.slickRef.slickPrev();
            setTimeout(() => this.setCurrentSlide(this.slickRef.innerSlider.state.currentSlide), 100);
        }
    };

    setCurrentSlide(index) {
        this.setState({
            currentSlide: index,
        });
    }

    setSlickRef = (ref) => {
        this.slickRef = ref;
    };

    render() {
        const { layout, title, withSidebar, loading } = this.props;
        const { currentSlide } = this.state;

        const blockClasses = classNames("block-faq-carousel", {
            "block-faq-carousel--loading": loading,
            "block-faq-carousel--has-items": faqList.length > 0,
        });
        const containerClasses = classNames({
            container: !withSidebar,
        });

        const FAQ = faqList.map((faq, index) => (
            <div key={index} className="block block-faq-carousel__cell">
                <div className="faq-box">
                    <div className="title">{faq.title}</div>
                    <hr />
                    <div className="desc">{faq.desc}</div>
                </div>
            </div>
        ));

        return (
            <div className={blockClasses}>
                <div className="container">
                    <div className="title1 container">
                        <h3 className="text-center text-color-theme mb-4">FAQ</h3>
                    </div>
                    <div className="block-faq-carousel__slider">
                        {currentSlide > 0 ? (
                            <span className="carousel-arrow-left" onClick={this.handlePrevClick}>
                                <ArrowPointToLeft />
                            </span>
                        ) : null}
                        <StroykaSlick ref={this.setSlickRef} {...settings} afterChange={(e) => this.setCurrentSlide(e)}>
                            {FAQ}
                        </StroykaSlick>
                        {faqList.length - 1 > currentSlide ? (
                            <span className="carousel-arrow-right" onClick={this.handleNextClick}>
                                <ArrowPointToRight />
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
